import React, { useCallback } from 'react';
import { Callout as DropDownCallout } from 'components/layout/Callout';
import { useInput } from '../hooks/useInput';

export interface ICalloutProps {
  popupOpen: boolean;
  closePopup: () => void;
  linkRef: React.RefObject<HTMLElement>;
  onSubmit: (result: string) => void;
}

const preventPropogation = (e: React.MouseEvent<HTMLInputElement, MouseEvent>): void => {
  e.stopPropagation();
};

export function Callout({ popupOpen, closePopup, linkRef, onSubmit }: ICalloutProps) {
  const [inpuValue, ddInput] = useInput({ type: 'text', placeholder: 'Type Input Name...', value: '' });

  const submit = useCallback(() => {
    onSubmit(inpuValue);
    closePopup();
  }, [onSubmit, inpuValue, closePopup]);

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      switch (e.key) {
        case 'Enter':
          submit();
          break;
        case 'Escape':
          closePopup();
          break;
      }
    },
    [closePopup, submit]
  );

  return (
    <DropDownCallout showArrow={true} isOpen={popupOpen} onClose={closePopup} sourceRef={linkRef} placement="bottom">
      <div onKeyDown={onKeyDown} onClick={preventPropogation} className="dpc-ddpath-editor-callout">
        <div className="dpc-ddpath-editor-callout__input">{ddInput}</div>
        <button className="dpc-ddpath-editor-callout__button dp-button dp-right" onClick={submit}>
          ADD
        </button>
      </div>
    </DropDownCallout>
  );
}
